define('js/stat',['require','exports','module','jquery','./radar'],function (require, exports, module) {
    var $ = require('jquery');
    var radar = require('./radar');

    //links clicks

    $(document).delegate('[data-category]', 'click', function (e) {
        var el = $(e.currentTarget);

        var category = el.data('category');
        var action = el.data('action');
        var label = el.data('label');

        radar.ga({
            category: category,
            action: action,
            label: label,
        });

        if (el.is('a') && !el.attr('target') && !e.metaKey && !e.ctrlKey && e.which === 1 && !el.hasClass('js-signin')) {
            e.preventDefault();

            setTimeout(function () {
                window.location = el.attr('href');
            }, 0);
        }
    });
});

